import { patch } from '..';

const bookmarkChatbotSession = async (sessionId: string, bookmarkedSession: boolean) => {
  const requestUrl = `chatbot-api/chat-sessions/${sessionId}/bookmark`;
  const body = { isBookmarked: !bookmarkedSession };
  await patch(requestUrl, body);
};

export default bookmarkChatbotSession;
